import { fetchClient } from '../../Utils/helpers';
import { getUserData } from '../../Utils/storages';
import { DETAIL_COURIER, GET_COURIER, POST_COURIER } from '../actionTypes';

const userData = getUserData();
const role = userData.role_id;

export function getCourier(query) {
  const {
    page = 1, limit = 100, status = '', sort = 'Newest', keyword = '',
  } = query;
  return {
    type: GET_COURIER,
    payload: fetchClient({
      method: 'GET',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/couriers?page=${page}&limit=${limit}&status=${status}&sort=${sort}&keyword=${keyword}`,
    }),
  };
}

export function createCourier(data) {
  return {
    type: POST_COURIER,
    payload: fetchClient({
      method: 'POST',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/courier`,
      data,
    }),
  };
}

export function updateCourier(data, id) {
  return {
    type: POST_COURIER,
    payload: fetchClient({
      method: 'PATCH',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/courier/${id}`,
      data,
    }),
  };
}

export function getCourierDetail(id) {
  return {
    type: DETAIL_COURIER,
    payload: fetchClient({
      method: 'GET',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/courier/${id}`,
    }),
  };
}
